import {
  createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import createHistory from 'history/createBrowserHistory';
import { reducer as form } from 'redux-form';

import { reducer as application } from './Application/reducer';
import { reducer as auth } from './Auth/reducer';
import { reducer as countries } from './Countries/reducer';
import { reducer as permissions } from './Permissions/reducer';
import { reducer as dashboard } from './Dashboard/reducer';
import { reducer as lastProducts } from './LastProducts/reducer';
import { reducer as toasts } from './Toasts/reducer';
import { reducer as collections } from './Collections/reducer';
import { reducer as categories } from './Categories/reducer';
import { reducer as locales } from './Locales/reducer';
import { reducer as productCollections } from './ProductCollections/reducer';
import { reducer as myManufacturers } from './MyManufacturers/reducer';
import { reducer as otherManufacturers } from './OtherManufacturers/reducer';
import { reducer as vendors } from './Vendors/reducer';
import { reducer as manufacturer } from './Manufacturer/reducer';
import { reducer as vendorDetails } from './VendorDetails/reducer';
import { reducer as catalog } from './Catalog/reducer';
import { reducer as collaborators } from './Collaborators/reducer';
import { reducer as invite } from './Invite/reducer';
import { reducer as rolePermissions } from './RolePermissions/reducer';
import { reducer as profile } from './Profile/reducer';

import { reducer as newProductForm } from './NewProductForm/reducer';
import { reducer as editProductForm } from './EditProductForm/reducer';
import { reducer as acceptInviteForm } from './AcceptInviteForm/reducer';
import { reducer as productQR } from './ProductQR/reducer';

import { reducer as planModal } from './PlanModal/reducer';

import { actions as authActions } from './Auth/actions';

export const history = createHistory();

// Add reducers here
const reducers = combineReducers({
  application,
  auth,
  form,
  countries,
  permissions,
  dashboard,
  lastProducts,
  toasts,
  collections,
  categories,
  locales,
  manufacturer,
  catalog,
  newProductForm,
  editProductForm,
  productCollections,
  planModal,
  myManufacturers,
  otherManufacturers,
  vendors,
  vendorDetails,
  collaborators,
  invite,
  rolePermissions,
  acceptInviteForm,
  profile,
  productQR,
});

const middlewares = [routerMiddleware(history)];
const enhancers = [];

/* ------------- Thunk Middleware ------------- */
middlewares.push(thunk);

/* ------------- Assemble Middleware ------------- */
enhancers.push(applyMiddleware(...middlewares));

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = (state, action) => {
  if (action.type === authActions.SIGN_OUT) {
    // eslint-disable-next-line no-undef
    return reducers(getGlobalState(state), action);
  }
  return reducers(state, action);
};

const store = createStore(
  connectRouter(history)(rootReducer),
  composeEnhancers(...enhancers),
);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js